import { Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import * as XLSX from 'xlsx';
declare var $: any;

interface ClientPreview {
  clientId: number;
  firstName: string;
  lastName: string;
  nationalId: string;
  email: string;
  username: string;
}

interface ClientError {
  firstName: string;
  lastName: string;
  nationalId: string;
  email: string;
  error: string;
}

@Component({
  selector: 'app-bulk-account-access',
  templateUrl: './bulk-account-access.component.html',
  styleUrls: ['./bulk-account-access.component.scss']
})

export class BulkAccountAccessComponent implements OnInit {
  isModalOpen = false;
  selectedAction: 'enable' | 'disable' = 'disable';
  file: File | null = null;
  
  validClients: ClientPreview[] = [];
  errorClients: ClientError[] = [];
  isProcessing = false;
  progress = 0;
  private progressInterval: any;
  isLoadingPreview = false;

  constructor(
    private lambdaService: LambdaService,
    private themingService: ThemingService
  ) {}

  ngOnInit(): void {}

  openModal(): void {
    // this.isModalOpen = true;
    $('#bulkAccountAccessModal').modal('show');
    this.resetState();
  }

  closeModal(): void {
    // this.isModalOpen = false;
    $('#bulkAccountAccessModal').modal('hide');
    this.clearProgressInterval();
    this.isProcessing = false;
    this.progress = 0;
    this.isModalOpen = false;
    this.resetState();
  }

  resetState(): void {
    this.file = null;
    this.validClients = [];
    this.errorClients = [];
    this.isProcessing = false;
    this.progress = 0;
    this.clearProgressInterval();
    this.isLoadingPreview = false;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      this.processExcelFile(this.file);
    }
  }

  async downloadTemplate() {
      const XLSX_ = XLSX;
      // Crear libro Excel
      const wb = XLSX_.utils.book_new();
      // Encabezados del archivo
      const headers = [
        'cedula'
      ];
      // Crear una fila de ejemplo (opcional)
      const sampleRow = {
        cedula: '',
      };
      // Convertir la fila en hoja
      const ws = XLSX_.utils.json_to_sheet([sampleRow], { header: headers });
      // Agregar la hoja al libro
      XLSX_.utils.book_append_sheet(wb, ws, 'cedulas');
      // Descargar archivo
      XLSX_.writeFile(wb, 'Plantilla_Desactivacion_Clientes.xlsx');
    }

  private processExcelFile(file: File): void {
    this.isLoadingPreview = true;
    const reader = new FileReader();
    
    reader.onload = async (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const json: any[] = XLSX.utils.sheet_to_json(worksheet);

      // Extraer solo la columna 'cedula' (o nationalId)
      const nationalIds = json.map(row => String(row.cedula || row.nationalId || '').trim()).filter(id => id.length > 0);

      // Eliminar duplicados
      const uniqueNationalIds = [...new Set(nationalIds)];

      let results: any = await this.lambdaService.getClientsToDisabled(this.themingService.shopTheming[0].shopId, uniqueNationalIds);
      console.log("getClientsToDisabled", results);
      if(results && results.success) {
        this.validClients = results.validClients || [];
        this.errorClients = results.errorClients || [];
      } else {
        this.validClients = [];
        this.errorClients = [];
      }
      this.isLoadingPreview = false;
    };
    
    reader.readAsArrayBuffer(file);
  }

  downloadErrorReport(): void {
    if (this.errorClients.length === 0) return;
    
    const worksheet = XLSX.utils.json_to_sheet(this.errorClients);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Errores');
    XLSX.writeFile(workbook, 'reporte_clientes_no_procesados.xlsx');
  }

  async processBulk(): Promise<void> {
    if (this.validClients.length === 0) return;
    
    this.isProcessing = true;
    this.progress = 0; // Reiniciar progreso
    
    const clients: any[] = this.validClients.map(c => ({
      clientId: c.clientId,
      username: c.username,
    }));

    try {
      const response: any = await this.lambdaService.bulkAccountAccess(
        this.themingService.shopTheming[0].shopId, 
        this.selectedAction, 
        clients, 
        this.themingService.shopTheming[0].amplifyConfig
      );
      
      console.log("RESPUESTA DE bulkAccountAccess", response);
      
      if (response && response.success) {
        // Iniciar la simulación de progreso basada en el tiempo estimado
        this.startProgressSimulation();
      } else {
        alert('Error al iniciar el proceso.');
        this.isProcessing = false;
      }
    } catch (error) {
      console.error("Error en processBulk:", error);
      alert('Error de conexión al iniciar el proceso.');
      this.isProcessing = false;
    }
  }

  private startProgressSimulation(): void {
    const totalClients = this.validClients.length;
    
    // 10 clientes = 6000 ms  =>  1 cliente = 600 ms
    const estimatedTimeMs = totalClients * 600; 
    
    // Actualizamos la barra cada 100 ms para que se vea fluida
    const updateIntervalMs = 100; 
    
    // Calculamos cuánto porcentaje sumar en cada intervalo de 100ms
    const progressIncrement = (updateIntervalMs / estimatedTimeMs) * 100;

    this.progressInterval = setInterval(() => {
      this.progress += progressIncrement;
      
      // Limitamos a 99% para dar la sensación de "Finalizando..." 
      // y evitar que se cierre si el backend se retrasa un poco más de lo estimado.
      // Cuando llegue a 99%, esperamos un poco y cerramos.
      if (this.progress >= 99) {
        this.progress = 99;
        clearInterval(this.progressInterval);
        
        // Forzamos el cierre después de 1.5 segundos adicionales de "Finalizando..."
        setTimeout(() => {
          this.progress = 100;
          setTimeout(() => {
            this.closeModal();
          }, 300);
        }, 1500);
      }
    }, updateIntervalMs);
  }

  private clearProgressInterval(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }

  // Buena práctica: limpiar el intervalo si el componente se destruye
  ngOnDestroy(): void {
    this.clearProgressInterval();
  }

}
